module.exports = __webpack_public_path__ + "static/logo_white@2x-8f3c4ae2159ad8fc965a269684d6f49b.png";